var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48.8963 44.3388V13.7573C48.8963 11.5482 47.1054 9.75732 44.8963 9.75732H19.1045C16.8954 9.75732 15.1045 11.5482 15.1045 13.7573V50.2436C15.1045 52.4528 16.8954 54.2436 19.1045 54.2436H38.9915M48.8963 44.3388H42.9915C40.7823 44.3388 38.9915 46.1297 38.9915 48.3388V54.2436M48.8963 44.3388L38.9915 54.2436","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
